export enum WidgetsModel {
  LIVECHAT = "LIVECHAT",
  CALLBACK = "CALLBACK",
  VIDEO = "VIDEO"
}
